import each from 'lodash-es/each';
import get from "lodash-es/get";
import map from "lodash-es/map";
import isEmpty from "lodash-es/isEmpty";
import join from "lodash-es/join";
import toString from "lodash-es/toString";
import find from "lodash-es/find";
import toNumber from "lodash-es/toNumber";
import set from "lodash-es/set";
import max from "lodash-es/max";
import debounce from "lodash-es/debounce";
import some from "lodash-es/some";

class FastBuy {
  constructor(elem) {
    this.block = elem;
    this.block.ins = this;
    this.$block = $(this.block);
    this.$modal = $('#MODAL_FAST_BUY');
    this.actionInfo = this.$block.data('action-info') || '/rest/stores/get-stores-with-product-info.json';
    this.actionBuy = this.$block.data('action-buy') || '/rest/order/create-fast-order.json';
    this.actionTel = this.$block.data('action-tel') ||'/rest/validator/phone';
    this.mapTabId = 'FAST_BUY_PICKUP_MAP';
    this.id = this.$block.data('id');
    this.sessid = window.BX ? window.BX.bitrix_sessid() : '';
    this.stores = [];
    this.current = null;
    this.order = null;
    this.count = 1;
    this.product = {
      price: toString(this.$block.data('available-price')),
      manufacturer: toString(this.$block.data('manufacturer')),
      name: toString(this.$block.data('available-name')),
      mnn: toString(this.$block.data('mnn')),
      barcode: toString(this.$block.data('barcodes')),
      image: toString(this.$block.data('available-image')),
    };
    this.media = window.matchMedia('(max-width:768px)');
    this.isMobile = window.matchMedia('(max-width:768px)').matches;
    this.info().then(() => {
      this.render();
      this.media.addEventListener('change', (event) => {
        if (this.isMobile !== event.matches) {
          this.isMobile = event.matches;
          this.render();
        }
      });
    });
  }

  fetch = ({ url, options }) => {
    this.$modal.find('.modal-fast-buy__content').addClass('loader');
    return $.ajax(url + `?sessid=${this.sessid}`, {
      dataType: 'json',
      contentType: "application/json",
      ...options,
      data: JSON.stringify(options['data']),
    }).always((response) => {
      const sessid = get(response, 'responseJSON.result.sessid', '');
      if (sessid && sessid !== this.sessid) this.sessid = sessid;
      this.$modal.find('.modal-fast-buy__content').removeClass('loader')
    });
  }

  validation = async () => {
    const $form = this.$modal.find('.user-form');
    const $userErrors = $form.find('.user-form__errors');
    const $pickupErrors = this.$modal.find('.modal-fast-buy__pickup-errors');
    const $backErrors = this.$modal.find('.modal-fast-buy__back-errors');
    const store = get(this.current, 'id');
    $backErrors.html('');
    $userErrors.html('');
    if (!store) {
      $pickupErrors.html(await this.apply({content: 'Выберите аптеку'}));
      $pickupErrors.get(0).scrollIntoView({behavior: 'smooth'});
      return false;
    }
    $pickupErrors.html('');
    const valid = some([...$form.get(0).elements], (elem) => {
      return this.formValidate(elem, $userErrors)
    });
    if (valid) return false;
    const tel = await this.check($form.find('[name="user-form-tel"]').val());
    if (get(tel, 'error')) {
      $backErrors.html(get(tel, 'message'));
      $backErrors.get(0).scrollIntoView({behavior: 'smooth'});
      return false;
    }

    return $form.get(0).checkValidity();
  }

  buy = debounce(async (evt) => {
    evt.preventDefault();
    const valid = await this.validation();
    if (!valid) return;
    const $form = this.$modal.find('.user-form');
    const $userErrors = $form.find('.user-form__errors');
    const data = $form.serializeArray();
    const agreements = $form.find('[data-agreement-checkbox]').toArray();
    const store = get(this.current, 'id');

    this.fetch({ url: this.actionBuy, options: {
        method: 'POST',
        data: {
          data: {
            user: {
              name: get(find(data, {name: 'user-form-name'}), 'value'),
              mail: get(find(data, {name: 'user-form-email'}), 'value'),
              tel: get(find(data, {name: 'user-form-tel'}), 'value'),
            },
            basket: [
              {
                product_id: toString(this.id),
                quantity: this.count,
              }
            ],
            store,
            agreements: map(agreements, 'value'),
          },
        },
      }}).done(async (response) => {
      this.order = get(response, 'result.order_id');
      this.modalText = get(response, 'result.html_text', '');

      if (this.order) {
        const success = await this.getSuccessHtml();
        this.$modal.find('.modal-fast-buy__card').html("");
        this.$modal.find('.modal-fast-buy__pickup').html("");
        this.$modal.find('.modal-fast-buy__footer').html("");
        this.$modal.find('.modal-fast-buy__body').addClass('d-none');
        this.$modal.find('.modal-fast-buy__title').addClass('d-none');
        this.$modal.find('.modal-fast-buy__success').html(success);
        $userErrors.html('');
      }

    }).fail((response) => {
      const error = get(response, 'responseJSON.error_description', get(response, 'responseJSON.result.message'));
      if (error) this.$modal.find('.modal-fast-buy__back-errors').html(error);
    })
  }, 500)

  check = (tel) => new Promise((resolve) => {
    this.fetch({ url: this.actionTel, options: {
        method: 'POST',
        dataType: 'json',
        data: { tel },
      }}).always((response) => {
      if (get(response, 'state') === 400 || get(response, 'statusText') === 'error') resolve(get(response, 'responseJSON.result'));
      resolve(true);
    })
  })

  apply = (json) => new Promise((resolve) => window.getBH((bh) => resolve(bh.apply(json))));

  info = () => new Promise((resolve) => {
    this.$block.find('.btn').addClass('disabled');
    if (!this.actionInfo && window.Resellers) {
      this.stores = window.Resellers;
      this.$block.find('.btn').removeClass('disabled');
      resolve(this.stores);
    }
    else {
      const info = get(window, ['StoresInfo', join([this.id, this.actionInfo], '-')], []);
      if (!isEmpty(info)) {
        this.stores = info;
        this.$block.find('.btn').removeClass('disabled');
        resolve(this.stores);
      }
      else {
        const id = this.id;

        const current = new Date();
        const tomorrow = new Date(); tomorrow.setDate(new Date().getDate() + 1);
        this.fetch({url: this.actionInfo, options: {
            method: process.env.NODE_ENV === 'development' ? 'GET' : 'POST',
            data: { id },
          }}).done((response) => {
          const items = get(response, ['result', 'items', this.id], []);
          const stores = get(response, 'result.storesInfo');
          this.stores = map(items.stores, ({ id, date, amount }) => {
            const store = get(stores, id);
            const dateFormat = date;
            return Object.assign({
              id,
              coordinates: [ get(store, 'gpsN'), get(store, 'gpsS') ],
              address: get(store, 'address'),
              phone: get(store, 'phone'),
              time: get(store, 'schedule'),
              amount,
              inStock: dateFormat === current.toLocaleDateString(),
            }, date ? {
              date: dateFormat,
              order: dateFormat === current.toLocaleDateString(),
            }: {})
          });
          set(window, ['StoresInfo', join([this.id, this.actionInfo], '-')], this.stores);
          this.$block.find('.btn').removeClass('disabled');
          resolve(this.stores);
        })
      }
    }
  })

  render = async () => {
    this.$block.addClass('init');
    const handle = this.isMobile ? 'click' : 'mouseenter';
    this.$block.on(handle, '.btn', this.refresh);
  }

  refresh = async () => {
    const pickup = await this.getBlockHtml();
    const card = await this.getPanelHtml();
    const footer = await this.getFooterHtml();
    this.$modal.find('.modal-fast-buy__success').html('');
    this.$modal.find('.modal-fast-buy__body').removeClass('d-none');
    this.$modal.find('.modal-fast-buy__title').removeClass('d-none');
    this.moveDataOnModalPanel({ pickup, card, footer });
    window.Block?.Counter?.init();
    $(document).trigger('PageChange');
    // не получилось использовать всплытие и повесить обработчик один раз,
    // нужно обращение к конкретному инстансу для получения информации
    this.$modal.find('.counter').on('change', (evt) => {
      const $target = $(evt.currentTarget);
      const $input = $(evt.target);
      const max = toNumber($target.data('max'));
      this.count = $input.val();
      if (this.count >= max) this.$modal.find('.product-row__message').html(`<small class="text-danger">В наличии ${max}&nbsp;шт.</small>`)
      else this.$modal.find('.product-row__message').html('');
    });
    this.$modal.find('.pickup').on('click', '[data-action]', (evt) => {
      evt.preventDefault();
      const $target = $(evt.target);
      const action = $target.data('action');
      const id = toString($target.data('id'));
      if (action === 'fast') {
        if (id) {
          this.current = find(this.stores, { id });
          this.$modal.find('.modal-fast-buy__pickup-errors').html('');
          if (this.current) return this.refresh();
          }
        }
      if (action === 'change') {
        evt.preventDefault();
        this.current = null;
        this.refresh()
      }
    });
    this.$modal.find('[data-action="buy"]').on('click', this.buy);
    this.$modal.find('.counter input').trigger('change');
    const $form = this.$modal.find('.user-form');
    const $userErrors = $form.find('.user-form__errors');
    if (!$form.hasClass('handled')) {
      $form.on('change', (evt) => {
        this.formValidate(evt.target, $userErrors)
      });
      $form.addClass('handled');
    }
  }

  formValidate(elem, $container) {
    const empty = elem.validity.valueMissing;
    const mismatch = elem.validity.patternMismatch || elem.validity.typeMismatch;
    const $feedback = $(elem).next('small.text-danger').length ? $(elem).next('small.text-danger') : $container;
    if (empty) {
      $feedback.html($(elem).data('empty'));
      $(elem).addClass('border-danger');
      elem.focus();
      return true;
    }
    if (mismatch) {
      $feedback.html($(elem).data('mismatch'));
      $(elem).addClass('border-danger');
      elem.focus();
      return true;
    }
    $feedback.html('');
    $(elem).removeClass('border-danger');
    return false;
  }

  moveDataOnModalPanel({ pickup, card, footer }) {
    this.$modal.find('.modal-fast-buy__card').html(card);
    this.$modal.find('.modal-fast-buy__pickup').html(pickup);
    this.$modal.find('.modal-fast-buy__footer').html(footer);
    this.$modal.find('[data-toggle="popover"]').popover({trigger: 'hover', placement: 'top'});
  }

  getFooterHtml = () => this.apply([
    {block: 'btn', tag: 'button',  cls: 'btn-primary', attrs: {'data-action': 'buy', type: 'button'}, content: 'Купить'},
    {block: 'btn', tag: 'button', cls: 'btn-outline-primary', attrs: {'data-dismiss': 'modal', type: 'button' }, content: 'Отменить'},
  ]);

  getBlockHtml = () => this.apply([
    {block: 'pickup', content: [
        {elem: 'header', cls: 'mb-20', content: [
            {elem: 'title', tag: 'h4', cls: 'h4 my-0 mr-auto', content: 'Забрать из аптеки'},
            !this.current && {elem: 'buttons', cls: 'nav', content: [
                {elem: 'button', cls: 'active', attrs: {'data-toggle': 'tab', 'href': '#FAST_BUY_PICKUP_ADDRESS'}, content: [
                    {tag: 'span', content: 'Списком'},
                  ]},
                {elem: 'button', attrs: {'data-toggle': 'tab', 'href': '#'+this.mapTabId}, content: [
                    {tag: 'span', content: 'На карте'},
                  ]},
              ]},
          ]},
        !this.current && {cls: 'tab-content', content: [
            {cls: 'tab-pane fade show active', attrs: {id: 'FAST_BUY_PICKUP_ADDRESS'}, content: [
                {block: 'address-table', mods: {row: true}, attrs: {'data-related-map-tab': this.mapTabId, 'data-id': this.id, 'data-action-info': this.actionInfo}, content: [
                    {elem: 'search', content: [
                        {tag: 'input', cls: 'form-control', attrs: {placeholder: 'Город, улица, номер дома'}}
                      ]},
                    {elem: 'empty', cls: 'd-none', content: 'Ничего не найдено.'},
                    {elem: 'base', cls: '', content: [] },
                    {elem: 'collapse', cls: 'collapse', attrs: {'id': 'FAST_BUY_ADDRESS_TABLE'}, content: []},
                    {cls: 'mt-1 mt-md-2', content: [
                        {block: 'btn', attrs: {'data-target': '#FAST_BUY_ADDRESS_TABLE', 'data-toggle': 'collapse', 'data-read-more': true, 'data-text': 'Скрыть'}, cls: 'btn-outline-primary btn-block collapsed', content: [
                            {tag: 'span', content: 'Показать еще'},
                          ]},
                      ]},
                  ]},
              ]},
            {cls: 'tab-pane fade', attrs: {id: this.mapTabId}, content: [
                {block: 'map-available', attrs: {'data-id': this.id, 'data-action-info': this.actionInfo}, content: [
                    {elem: 'wrapper', content: [
                        {elem: 'search', content: [
                            {tag: 'input', cls: 'form-control', attrs: {placeholder: 'Город, улица, номер дома'}}
                          ]},
                        {elem: 'content'},
                      ]},
                  ]},
              ]},
          ]},
        this.current && {elem: 'current', content: [
            {block: 'address-table', elem: 'body', content: [
                {cls: 'row m-n2', content: [
                    {cls: 'col-auto py-2 pl-2 pr-0', content: [
                        {elem: 'mark', content: [
                            {block: 'fi', mods: {icon: 'mark'}, tag: 'i'}
                          ]},
                      ]},
                    {cls: 'col p-2', content: [
                        this.current.address && {elem: 'address', content: this.current.address},
                        this.current.time && {cls: 'font-size-middle text-lightgray', content: this.current.time},
                        this.current.phone && {elem: 'link', tag: 'a', cls: 'font-size-middle', attrs: {href: `tel:${this.current.phone}`}, content: this.current.phone},
                        this.current.inStock && {tag: 'b', cls: 'd-block', content: 'В наличии'},
                        {cls: 'mt-20', content: [
                            {block: 'btn', attrs: {'data-action': 'change'}, cls: 'btn-outline-primary', content: 'Изменить аптеку'}
                          ]},
                      ]},
                  ]},
              ]}
          ]},
      ]},
  ]);

  getPanelHtml = () => {
    const count = get(find(this.stores, { id: get(this.current, 'id') }), 'amount') ||  max(map(this.stores, 'amount'))
    return this.apply([
      {block: 'product-row', content: [
          {elem: 'image', content: [
              {block: 'image', mods: {size: '80x80'}, content: [
                  {block: 'img', src: this.product.image},
                ]},
            ]},
          {elem: 'body', content: [
              {elem: 'info', content: [
                  this.product.name && {elem: 'name', content: this.product.name},
                  this.product.barcode && {elem: 'meta', content: `Штрихкоды: ${this.product.barcode}`},
                  this.product.mnn && {elem: 'meta', content: `Действующее вещество: ${this.product.mnn}`},
                  this.product.manufacturer && {elem: 'meta', content: `Производитель: ${this.product.manufacturer}`},
                ]},
              {elem: 'actions', content: [
                  {elem: 'buy', content: [
                      {elem: 'message'},
                      {block: 'counter', attrs: {'data-min': 1, 'data-max': count,}, content: [
                          {elem: 'control', cls: 'btn btn-gradient-primary', tag: 'button', mods: {minus: true}, attrs: {'type': 'button', 'data-control-minus': true}},
                          {elem: 'input', cls: 'form-control  form-control-lg', tag: 'input', attrs: {
                              'placeholder': '1', 'data-inputmask': '"alias": "numeric", "rightAlign": false', value: 1
                            }},
                          {elem: 'control', cls: 'btn btn-gradient-primary', tag: 'button', mods: {plus: true}, attrs: {'type': 'button', 'data-control-plus': true}},
                        ]},
                    ]},
                  {elem: 'price', content: [
                      this.product.price.split('.')[0],
                      this.product.price.split('.').length > 1 && {elem: 'cent', tag: 'span', content: `.${this.product.price.split('.')[1]}`},
                      {elem: 'ruble', tag: 'span', content: '₽'},
                    ]},
                ]},
            ]},
        ]},
    ])
  };

  getSuccessHtml = () => {
    const base = 'images/order-result/checkmark-big-circle.svg';
    return this.apply([
      {cls: 'text-center', content: [
          {tag: 'img', cls: 'mb-3', attrs: {src: process.env.NODE_ENV === 'development' ? base : '/local/templates/main/dist/' + base}},
          {cls: 'h1 mb-3', content: 'Спасибо!'},
          this.modalText,
          {block: 'btn', cls: 'btn-outline-primary mt-3', attrs: {'data-dismiss': 'modal'}, content: 'Продолжить покупки'},
        ]},
    ])
  };

  static init() {
    const $fastBuy = $('.fast-buy:not(.init)');
    each($fastBuy, (elem) => {
      return new FastBuy(elem);
    })
  }
}


$(document).ready(() => FastBuy.init());
$(document).on('PageChange', () => FastBuy.init());

window.Block = window.Block ? window.Block : {};
window.Block.FastBuy = FastBuy;
